import { Turnstile } from "@marsidev/react-turnstile";
import { useVzhlad } from "../../context/VzhladContext";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

export const CaptchaWidget = ({ onVerify, turnstileRef }) => {
  // Podľa režimu aplikácie, nie zariadenia ("auto" by pri ručne zvolenom
  // tmavom režime na svetlom systéme ukázal biely widget).
  const { rezim } = useVzhlad();
  return (
    <div className="captcha-container" style={{ margin: "1rem 0" }}>
      <Turnstile
        ref={turnstileRef}
        siteKey={SITE_KEY}
        onSuccess={(token) => onVerify(token)}
        onError={() => onVerify(null)}
        onExpire={() => onVerify(null)}
        options={{ theme: rezim }}
      />
    </div>
  );
};
